/* 🤖 this file was generated by svg-to-ts */
export const IconBigMediumDateiDownload: {
    name: 'big-medium-datei-download';
    data: string;
} = {
    name: 'big-medium-datei-download',
    data: `<svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" viewBox="0 0 128 128"><path d="M60.46 102.79a5 5 0 0 0 .76.62 2 2 0 0 0 .23.12 4 4 0 0 0 .63.34c.11 0 .22.07.33.11a6 6 0 0 0 .6.18 5 5 0 0 0 2 0 6 6 0 0 0 .6-.18c.11 0 .22-.06.33-.11a5 5 0 0 0 .63-.33c.08-.05.16-.08.23-.13a5 5 0 0 0 .76-.62l45.12-45.13a5 5 0 0 0-7.07-7.07L69 87.19V9a5 5 0 0 0-10 0v78.19l-36.59-36.6a5 5 0 0 0-7.07 7.07zM120.41 114H7.59a5 5 0 0 0 0 10h112.82a5 5 0 0 0 0-10"/></svg>`,
};
